import { Box, Typography } from '@mui/material'
import { useGetPdfReportSectionQuery } from 'gqlTypes'
import React, { useCallback, useMemo, useRef, useState } from 'react'
import PdfReportSection from './Section'

type Props = {
  sectionId: string
  reportId: string
  favorites: boolean
  confidential: boolean
}

const PdfReportPrint: React.FC<Props> = ({
  sectionId,
  reportId,
  favorites,
  confidential,
}) => {
  const { data, loading } = useGetPdfReportSectionQuery({
    variables: { sectionId: sectionId, favorites: false },
  })
  const section = data?.pdfReportSection?.reportSection
  const childSections = data?.pdfReportSection?.childReportSections

  // don't render puppeteer element until all of the report elements are rendered before we grab HTML
  const loadedCount = useRef(0)
  const [loaded, setLoaded] = useState(false)

  const totalCount = useMemo(() => {
    if (loading) {
      return null
    } else {
      return [section, ...(childSections || [])].filter((x) => x).length
    }
  }, [data])
  const handleLoaded = useCallback(() => {
    loadedCount.current += 1
    if (loadedCount.current === totalCount) {
      setLoaded(true)
    }
  }, [totalCount])
  // don't render puppeteer element until all of the report elements are rendered before we grab HTML

  return (
    <>
      {section && (
        <PdfReportSection
          confidential={confidential}
          onLoadComplete={handleLoaded}
          reportId={reportId}
          sectionId={section.id}
          favorites={favorites}
          sectionTitle={section.title}
        />
      )}
      {childSections &&
        childSections.map((cs) => (
          <PdfReportSection
            confidential={confidential}
            onLoadComplete={handleLoaded}
            key={cs.id}
            reportId={reportId}
            sectionId={cs.id}
            sectionTitle={cs.title}
            favorites={favorites}
          />
        ))}
      {loaded && <Box className="wait-for-content-puppeteer"></Box>}
    </>
  )
}

export default PdfReportPrint
